export const gapi = window.gapi;
export const CLIENT_ID =
  "67213414023-b7po1q5ditutud5e3dijf56pigkupitv.apps.googleusercontent.com";
export const DISCOVERY_DOCS = [
  "https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest",
];
export const SCOPES = "https://www.googleapis.com/auth/calendar.readonly";
